import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import { useTranslation } from 'react-i18next';
import StateComponents from '../../../components/state-component/StateComponents';
import TableCustom from '../../../components/table/tableCustom';
import ManageState from './manageState';
import { debouncedApiCall } from '../../../utils/app.utils';
import { status_admission } from '../history-online-Admission/enum/admission.enum';

export default function ListApplicants() {
    const { t, i18n } = useTranslation();
    const {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,

        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
        status, 
        set_status,
        handleDownloadFile,
        checkPermit
    } = ManageState()
    return (
        <div className='w-full'>
            <ContainerLayout
                title={t("IBSC Online Admission")}

                content={
                    <div className='w-full'>

                        <StateComponents
                            otherProps={{ spacing: 2 }}
                            typeProps={[
                                {
                                    seq: 1,
                                    type: "TEXT_FIELD",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        placeholder: t("LIST_APPLICANTS_SEARCH_NAME"),
                                        onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                                    }
                                },
                                {
                                    seq: 2,
                                    type: "DATE_RANGE",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        onchange: handleChangeDateRange,
                                        value: date_range || [],
                                        onClear: handleClearDateRange,
                                        allowClear: true,
                                        placeholder: t("LIST_APPLICANTS_DATE_RANGE")
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_degree(e.target.value)
                                        },
                                        options: [{
                                            label: t('LIST_APPLICANTS_ALL_LEVELS'),
                                            value: "ALL",
                                        }, ...degree?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                                                value: item?.id_degree,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_degree || '',
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_id_faculty(e.target.value)
                                        },
                                        options: [{
                                            label: t('LIST_APPLICANTS_ALL_FACULTIES'),
                                            value: "ALL",
                                        }, ...faculty?.map((item: any) => {
                                            return {
                                                label: i18n.language === "en" ? (item?.faculty_name_eng || item?.faculty_name) : item?.faculty_name,
                                                value: item?.id_faculty,
                                            }
                                        })],
                                        selectId: "",
                                        value: id_faculty || '',
                                    }
                                },
                                {
                                    seq: 3,
                                    type: "SELECT",
                                    gridProps: {
                                        xs: 12,
                                        md: 2
                                    },
                                    fieldProps: {
                                        labelId: "ss",
                                        heading: "",
                                        onChange: (e) => {
                                            // handleChange('form_type', index, e.target.value);
                                            set_status(e.target.value)
                                        },
                                        options: [{
                                            label: t('LIST_APPLICANTS_ALL_STATUS'),
                                            value: "ALL",
                                        }, ...status_admission.map((x) => ({ ...x, label: t(x.label) }))],
                                        selectId: "",
                                        value: status || '',
                                    }
                                },

                                {
                                    seq: 6,
                                    type: "BUTTON",
                                    gridProps: {
                                        xs: 6,
                                        md: 2
                                    },
                                    hidden: !checkPermit.isView,
                                    fieldProps: {
                                        justifyContent: "flex-end",
                                        buttonData: [
                                            {
                                                seq: 1,
                                                key: "ADD2",
                                                label: t("LIST_APPLICANTS_DOWNLOAD_EXCEL"),
                                                buttonProps: {
                                                    onClick: () => {
                                                        handleDownloadFile()
                                                        // setShowModal("ADD")
                                                    },
                                                },
                                                type: "DOWNLOAD_CSV",
                                            }
                                        ]
                                    }
                                }
                            ]}
                        />

                        <section className='w-full mt-4'>
                            <TableCustom
                                tableMinWidth={1440}
                                tableFixedWidth
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy={sortBy}
                                sortType={sortType}
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={data?.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={handleRequestSort}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        </section>
                    </div>
                }
            />

        </div>
    )
}
